export default "__VITE_ASSET__5ff4d865__"